/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSubheaderBar = {
  init: function($section){

    // Add settings from schema to current object
    window.PXUTheme.jsSubheaderBar = $.extend(this, window.PXUTheme.getSectionData($section));

    this.element = $section[0];
    this.delegateElement = new domDelegate.Delegate(this.element);

    this.$el = $("#SubheaderBar");
    this.attachListeners();
  },
  attachListeners: function() {
    this.delegateElement.on('click', '[data-subheader-popup="close"]', this.closePopup.bind(this));
    this.delegateElement.on('click', '[data-klaviyo-popup="open"]', this.openKlaviyoPopup.bind(this));
    this.delegateElement.on('click', '[data-bar-link]', this.barRedirect.bind(this));
    for(const el of document.querySelectorAll('[data-subheader-popup="open"]')) {
      el.addEventListener('click', this.openPopup.bind(this));
    }
  },
  barRedirect() {
    window.location = this.bar_link;
  },
  openPopup: function() {
    this.popup = this.element.querySelector(".SubheaderBar-popup");
    if (this.popup === null) return;
    this.popupInstance = $.fancybox.open(this.popup, {
      baseClass: `currency__lightbox selected_country_${this.selected_country}`,
      animationEffect: "fade",
      animationDuration: 600,
      parentEl: this.element,
      hash: false,
      infobar : false,
      toolbar: false,
      smallBtn : true,
      touch: false,
      mobile: {
        preventCaptionOverlap: false,
        toolbar: false,
      },
      onActivate: (instance) => {
        $('html').addClass("no-scroll");
      },
      afterClose: (instance) => {
        $('html').removeClass("no-scroll");
        this.closePopup.bind(this);
      }
    });
  },
  closePopup: function() {
    this.popupInstance.close();
  },
  disableSticky: function() {
    // Remove sticky functionality and recalculate offset for header sticky
    this.$el.unstick();
  },
  unload: function($section) {
    $('#SubheaderBar').off();
    $('#SubheaderBar').unstick();
  },
  openKlaviyoPopup: function(argument) {
    eval(this.klaviyo_code);
  }
}

/******/ })()
;